import { IAuthorization, IUserGroup_Authorization } from "bets.oddprovider.lib.common.ts/models"
import { ApiClientUtils } from "fwork-jsts-common/src/apiClient"
import { FormItemStyled, FormStyled } from "fwork.react.apptemplate"
import { useSnackbar } from "notistack"
import React, { useState } from 'react'
import { FaTrash } from "react-icons/fa"
import { AuthorizationsApiClient } from "../../apiClient/authorizations"
import axios from '../../apiClient/axios'
import { DEFAULTGAP } from "../../globals"
import { DropDownSearchComponent } from "../common/dropDownSearch"
import { HeaderComponent } from "../common/header"

export const UserGroupAuthorizationsComponent = (props: {
  data?: IUserGroup_Authorization[],
  onSelectItem?: (item: IUserGroup_Authorization, authorization: IAuthorization) => void | undefined,
  onDelete?: (item: IUserGroup_Authorization) => void,
  onAdd?: () => void,
}) => {
  const { enqueueSnackbar } = useSnackbar()

  const [gettingAuthorizations, setGettingAuthorizations] = useState<boolean>(false)
  const getAuthorizations = async (filter: string) => {
    if (gettingAuthorizations) return
    setGettingAuthorizations(true)
    try {
      const response = await new AuthorizationsApiClient(axios).get({
        where: {
          name: { $regex: filter, $options: 'i' }
        },
        exclude: '_id',
        sort: { name: 1 }
      })
      return response.data?.payload
    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    } finally {
      setGettingAuthorizations(false)
    }
  }

  return <div style={{
    paddingTop: DEFAULTGAP
  }}>
    <HeaderComponent
      title=''
      onAddClick={props.onAdd}
    />
    <FormStyled>
      {props.data?.map((u_g, idx) => <FormItemStyled key={idx} gap={DEFAULTGAP}
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          rowGap: DEFAULTGAP,
          columnGap: DEFAULTGAP,
        }}>
        <DropDownSearchComponent
          initInputValue={u_g.authorization?.name || ''}
          progress={gettingAuthorizations}
          style={{ width: '100%' }}
          label="Autorização"
          modelLabelName="name"
          // modelKeyName="id"
          dataBuilder={async (typedText: string | undefined) => {
            if (typedText)
              return await getAuthorizations(typedText)
          }}
          onSelectItem={(authorization: IAuthorization) => {
            if (props.onSelectItem)
              props.onSelectItem(u_g, authorization)
          }}
        />
        <FaTrash style={{ cursor: 'pointer', paddingInline: 2, }} color='grey' size={20} onClick={() => {
          if (props.onDelete)
            props.onDelete(u_g)
        }} />
      </FormItemStyled>)}
    </FormStyled>
  </div>
}